import type { AppModule } from '@/shared/types';
import * as routes from '@/modules/prayer-experience/routes';

export const PrayerExperienceModule: AppModule = {
  routes,
};
